<template>
  <div class="p-6 backdrop-blur-lg bg-white/60 border border-white/30 rounded-xl">
    <!-- Header -->
    <div class="bg-white rounded-xl shadow-md p-4 mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      <div class="flex items-center space-x-3 space-x-reverse">
        <div class="p-3 rounded-lg bg-gradient-to-r from-purple-100 to-blue-100 text-purple-500">
          <i class="fas fa-handshake text-xl"></i>
        </div>
        <div>
          <h1 class="text-xl font-bold text-gray-800">مدیریت شریک‌ها</h1>
          <p class="text-xs text-gray-500 mt-1">
          </p>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row gap-3">
        <div class="relative">
          <input
              v-model="search"
              type="text"
              class="border rounded-lg pr-9 pl-3 py-2 text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 w-96"
              placeholder="جستجو"
          >
          <span class="absolute right-2 top-2.5 text-gray-400">
            <i class="fas fa-search text-xs"></i>
          </span>
        </div>

        <!-- New Partner -->
        <button
            @click="resetToCreate"
            class="px-4 py-2 rounded-lg bg-gradient-to-r from-blue-500 to-purple-500 text-white text-sm font-medium shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-200"
        >
          <i class="fas fa-plus ml-2"></i>
          شریک جدید
        </button>
      </div>
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-3 gap-4">
      <div>
        <div class="bg-white rounded-xl shadow-md border border-gray-100 p-4 xl:sticky xl:top-4">
          <div class="flex items-center justify-between mb-3">
            <div>
              <h3 class="text-sm font-bold text-gray-800">
                {{ isEditMode ? 'ویرایش شریک' : 'شریک جدید' }}
              </h3>
              <p class="text-[11px] text-gray-500 mt-1">
                {{ isEditMode ? 'در حال ویرایش: ' + (form.name || '---') : 'فرم ساخت شریک + کاربر' }}
              </p>
            </div>
            <span
                v-if="isEditMode"
                class="px-2 py-1 rounded-full bg-blue-50 text-blue-600 text-[10px]"
            >
              حالت ویرایش
            </span>
          </div>

          <form @submit.prevent="submitPartner" class="space-y-4">
            <!-- Partner Fields -->
            <div class="border-b pb-3 mb-3">
              <h4 class="text-xs font-semibold text-gray-700 mb-2">اطلاعات شریک</h4>
              <div class="space-y-3">
                <div>
                  <label class="block text-xs text-gray-600 mb-1">نام شریک *</label>
                  <input
                      v-model="form.name"
                      type="text"
                      class="w-full border rounded-lg px-3 py-2 text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400"
                      required
                  >
                </div>

                <div>
                  <label class="block text-xs text-gray-600 mb-1">کد شریک (یونیک)</label>
                  <input
                      :value="codeDisplay"
                      type="text"
                      class="w-full border rounded-lg px-3 py-2 text-sm bg-gray-100 text-gray-600 cursor-not-allowed"
                      disabled
                  >
                  <p class="text-[10px] text-gray-400 mt-1">
                    این کد در فرانت خودکار ساخته می‌شود و به سرور ارسال می‌گردد.
                  </p>
                </div>

                <div>
                  <label class="block text-xs text-gray-600 mb-1">انبار مرتبط (اختیاری)</label>
                  <store-select
                      v-model="form.store"
                      :not_in="[]"
                  />
                  <p class="text-[10px] text-gray-400 mt-1">
                    فقط لینک منطقی است؛ خودبه‌خود موجودی به انبار اضافه نمی‌کند.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h4 class="text-xs font-semibold text-gray-700 mb-2">کاربر پنل شریک</h4>


              <div class="grid grid-cols-1 gap-3 bg-gray-50 rounded-lg p-3">
                <div class="mb-3 w-full">
                  <label class="block text-xs text-gray-600 mb-1">
                    انتخاب کاربر موجود
                  </label>
                  <UserSelect  ref="partnerUserSelect" :clearable="true" v-model="form.user" user-type="prtnr"  select-style="w-full border rounded-lg px-3 py-1.5 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"/>
                  <p class="text-[10px] text-gray-400 mt-1">
                    اگر شریک از قبل کاربر دارد، از اینجا انتخاب کن. در غیر این صورت، فرم زیر را پر کن تا کاربر جدید ساخته شود.
                  </p>
                </div>

                <div v-if="!form.user">
                  <label class="block text-xs text-gray-600 mb-1">نام  کاربر جدید</label>
                  <input
                      v-model="newUser.first_name"
                      type="text"
                      class="w-full border rounded-lg px-3 py-1.5 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"
                      :disabled="!!form.user"
                  >
                </div>
                <div v-if="!form.user">
                  <label class="block text-xs text-gray-600 mb-1">نام خانوادگی کاربر جدید</label>
                  <input
                      v-model="newUser.last_name"
                      type="text"
                      class="w-full border rounded-lg px-3 py-1.5 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"
                      :disabled="!!form.user"
                  >
                </div>
                <div v-if="!form.user">
                  <label class="block text-xs text-gray-600 mb-1">نام کاربری </label>
                  <input
                      v-model="newUser.username"
                      type="text"
                      class="w-full border rounded-lg px-3 py-1.5 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"
                      :disabled="!!form.user"
                      placeholder="مثلاً partner001"
                  >
                </div>
                <div v-if="!form.user">
                  <label class="block text-xs text-gray-600 mb-1">کلمه عبور</label>
                  <input
                      v-model="newUser.password"
                      type="password"
                      class="w-full border rounded-lg px-3 py-1.5 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"
                      :disabled="!!form.user"
                  >
                </div>
                <p class="text-[10px] text-gray-400">
                  اگر کاربر انتخاب شده باشد، این فیلدها نادیده گرفته می‌شوند.
                  اگر کاربر انتخاب نشود، پر بودن username و password برای ساخت کاربر جدید ضروری است.
                </p>
              </div>
            </div>

            <div class="flex justify-between items-center pt-2 border-t mt-4">
              <button
                  type="button"
                  @click="resetToCreate"
                  class="px-3 py-2 rounded-lg border text-xs text-gray-600 hover:bg-gray-50"
              >
                جدید / ریست فرم
              </button>

              <div class="flex gap-2">
                <button
                    v-if="isEditMode"
                    type="button"
                    @click="confirmDeleteByForm"
                    class="px-3 py-2 rounded-lg bg-red-50 text-red-600 text-xs hover:bg-red-100"
                >
                  حذف شریک
                </button>
                <button
                    type="submit"
                    :disabled="isSubmitting"
                    class="px-4 py-2 rounded-lg justify-center bg-blue-600 text-white text-xs font-medium hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed flex items-center text-center gap-2"
                >
                  <i v-if="isSubmitting" class="fas fa-spinner fa-spin text-xs text-center"></i>
                  <span class="text-blue-100 text-center">{{ isEditMode ? 'ثبت تغییرات' : 'ایجاد شریک + کاربر' }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="xl:col-span-2">
        <div class="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
          <div class="flex items-center justify-between px-4 py-3 border-b bg-gray-50">
            <div class="text-xs text-gray-500">
              {{ filteredPartners.length }} شریک پیدا شد
            </div>
            <button
                v-if="isLoading"
                class="flex items-center gap-2 text-xs text-gray-500"
                disabled
            >
              <i class="fas fa-spinner fa-spin"></i>
              در حال بارگذاری...
            </button>
          </div>

          <div class="overflow-x-auto">
            <table class="w-full text-sm">
              <thead class="bg-gray-100">
              <tr>
                <th class="py-2 px-3 text-center text-xs font-medium text-gray-600">ردیف</th>
                <th class="py-2 px-3 text-right text-xs font-medium text-gray-600">نام شریک</th>
                <th class="py-2 px-3 text-right text-xs font-medium text-gray-600">کد شریک</th>
                <th class="py-2 px-3 text-right text-xs font-medium text-gray-600">کاربر پنل</th>
                <th class="py-2 px-3 text-right text-xs font-medium text-gray-600">انبار مرتبط</th>
                <th class="py-2 px-3 text-center text-xs font-medium text-gray-600">اقدامات</th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-100">
              <tr
                  v-for="(partner, index) in filteredPartners"
                  :key="partner.id"
                  class="hover:bg-blue-50/40 transition-colors cursor-pointer"
                  @click="selectPartner(partner)"
              >
                <td class="py-2 px-3 text-center text-xs text-gray-600">
                  {{ index + 1 }}
                </td>
                <td class="py-2 px-3 text-right font-medium text-gray-800">
                  {{ partner.name || '---' }}
                </td>
                <td class="py-2 px-3 text-right text-gray-700">
                  <span class="px-2 py-1 rounded-full bg-gray-100 text-xs font-mono">
                    {{ partner.code || '---' }}
                  </span>
                </td>
                <td class="py-2 px-3 text-right text-gray-700 text-xs">
                  <span v-if="partner.user_name">{{ partner.user_name }}</span>
                  <span v-else class="text-gray-400">ست نشده</span>
                </td>
                <td class="py-2 px-3 text-right text-gray-700 text-xs">
                  <span v-if="partner.store_name"> {{ partner.store_name }}</span>
                  <span v-else class="text-gray-400">ست نشده</span>
                </td>
                <td class="py-2 px-3 text-center">
                  <div class="flex items-center justify-center gap-2">
                    <button
                        @click.stop="selectPartner(partner)"
                        class="px-2 py-1 rounded-lg bg-blue-50 text-blue-600 text-xs hover:bg-blue-100"
                    >
                      ویرایش
                    </button>
                    <button
                        @click.stop="confirmDelete(partner)"
                        class="px-2 py-1 rounded-lg bg-red-50 text-red-600 text-xs hover:bg-red-100"
                    >
                      حذف
                    </button>
                  </div>
                </td>
              </tr>

              <tr v-if="!isLoading && !filteredPartners.length">
                <td colspan="6" class="py-6 text-center text-xs text-gray-400">
                  هیچ شریکی با این فیلتر پیدا نشد.
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import UserSelect from '@/components/selects/UserSelect'
import StoreSelect from '@/components/selects/StoreSelect'

export default {
  name: 'PartnerManagement',
  components: {
    UserSelect,
    'store-select': StoreSelect,
  },
  data () {
    return {
      partners: [],
      isLoading: false,
      isSubmitting: false,
      search: '',
      isEditMode: false,
      form: {
        id: null,
        name: '',
        code: null,
        user: null,
        store: null
      },
      newUser: {
        first_name: '',
        last_name: '',
        username: '',
        password: ''
      }
    }
  },
  computed: {
    filteredPartners () {
      const term = (this.search || '').toString().trim().toLowerCase()
      if (!term) return this.partners
      return this.partners.filter(p => {
        const name = (p.name || '').toLowerCase()
        const code = (p.code || '').toLowerCase()
        return name.includes(term) || code.includes(term)
      })
    },
    codeDisplay () {
      if (this.form.code) return this.form.code
      return this.isEditMode ? '---' : 'به‌محض ذخیره‌سازی تولید می‌شود'
    }
  },
  methods: {
    generatePartnerCode () {
      const now = new Date()
      const y = now.getFullYear().toString().slice(-2)
      const m = (now.getMonth() + 1).toString().padStart(2, '0')
      const d = now.getDate().toString().padStart(2, '0')
      const rnd = Math.floor(Math.random() * 9999).toString().padStart(4, '0')
      return `PRT-${y}${m}${d}-${rnd}`
    },
    fetchPartners () {
      this.isLoading = true
      this.request({
        url: this.endpoint('partner-stock/partners/'),
        method: 'get',
        success: (data) => {
          this.partners = data.results || data
          this.isLoading = false
        },
        error: () => {
          this.isLoading = false
        }
      })
    },
    resetToCreate () {
      this.isEditMode = false
      this.form = {
        id: null,
        name: '',
        code: this.generatePartnerCode(),
        user: null,
        store: null
      }
      this.newUser = {
        first_name: '',
        last_name: '',
        username: '',
        password: ''
      }
    },
    selectPartner (partner) {
      this.isEditMode = true
      this.form = {
        id: partner.id,
        name: partner.name,
        code: partner.code,
        user: partner.user,
        store: partner.store
      }
      this.newUser = {
        first_name: '',
        last_name: '',
        username: '',
        password: ''
      }
    },
    async submitPartner () {
      if (!this.form.name) {
        return this.$toast?.error?.('نام شریک الزامی است')
      }

      this.isSubmitting = true

      try {
        if (!this.form.user) {
          if (!this.newUser.username || !this.newUser.password) {
            this.isSubmitting = false
            return this.$toast?.error?.('برای ساخت کاربر جدید، username و password الزامی است')
          }

          const userPayload = {
            username: this.newUser.username,
            password: this.newUser.password,
            first_name: this.newUser.first_name || '',
            last_name: this.newUser.last_name || '',
            user_type: 'prtnr'
          }

          await new Promise((resolve, reject) => {
            this.request({
              url: this.endpoint('partner-stock/partner-users/'),
              method: 'post',
              data: userPayload,
              success: (res) => {
                this.form.user = res.id
                this.$nextTick(() => {
                  if (this.$refs.partnerUserSelect && this.$refs.partnerUserSelect.reload) {
                    this.$refs.partnerUserSelect.reload()
                  }
                })
                resolve()

              },
              error: (err) => {
                console.error(err)
                reject(err)
              }
            })
          })
        }

        const partnerPayload = {
          name: this.form.name,
          code: this.form.code || this.generatePartnerCode(),
          user: this.form.user,
          store: this.form.store
        }

        const url = this.isEditMode && this.form.id
            ? this.endpoint(`partner-stock/partners/${this.form.id}/`)
            : this.endpoint('partner-stock/partners/')

        const method = this.isEditMode && this.form.id ? 'patch' : 'post'

        this.request({
          url,
          method,
          data: partnerPayload,
          success: (res) => {
            this.isSubmitting = false
            this.successNotify?.()
            this.fetchPartners()
            if (!this.isEditMode) {
              this.isEditMode = true
              this.form.id = res.id
              this.form.code = res.code
            }
          },
          error: (err) => {
            console.error(err)
            this.isSubmitting = false
            this.$toast?.error?.('خطا در ذخیره شریک')
          }
        })
      } catch (e) {
        this.isSubmitting = false
      }
    },
    confirmDelete (partner) {
      if (!window.confirm(`شریک "${partner.name}" حذف شود؟`)) return
      this.deletePartner(partner.id)
    },
    confirmDeleteByForm () {
      if (!this.form.id) return
      if (!window.confirm(`شریک "${this.form.name}" حذف شود؟`)) return
      this.deletePartner(this.form.id)
    },
    deletePartner (id) {
      this.request({
        url: this.endpoint(`partner-stock/partners/${id}/`),
        method: 'delete',
        success: () => {
          this.$toast?.success?.('شریک با موفقیت حذف شد')
          this.fetchPartners()
          this.resetToCreate()
        },
        error: () => {
          this.$toast?.error?.('حذف شریک با خطا مواجه شد')
        }
      })
    }
  },
  mounted () {
    this.fetchPartners()
    this.resetToCreate()
  }
}
</script>

<style scoped>
[dir="rtl"] .space-x-reverse > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}
</style>
